import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import {
  PrivacyTipOutlined,
  PaymentOutlined,
  CookieOutlined,
  SecurityOutlined,
  GavelOutlined,
  CloudOutlined,
  ContactMailOutlined,
  PersonOutlineOutlined,
} from "@mui/icons-material";
import Footer from "./Footer";

function PrivacyPolicy() {
  const sections = [
    {
      icon: <PersonOutlineOutlined fontSize="large" color="primary" />,
      title: "Information We Collect",
      points: [
        "Name",
        "Email Address",
        "Mobile Number",
        "City",
        "Educational Interests",
        "Courses or Services You Are Interested In",
        "Payment Transaction Details",
        "Login Credentials",
      ],
    },
    {
      icon: <PrivacyTipOutlined fontSize="large" color="success" />,
      title: "Why We Collect Your Information",
      points: [
        "Create and manage your account",
        "Allow you to join buying groups",
        "Contact you regarding negotiations",
        "Process payments securely",
        "Improve our products and services",
        "Send important notifications",
        "Prevent fraud and abuse",
      ],
    },
    {
      icon: <PaymentOutlined fontSize="large" color="warning" />,
      title: "Payment Information",
      points: [
        "Payments are processed securely using trusted providers such as Razorpay.",
        "PriceWorth never stores debit card numbers, credit card numbers, CVV, UPI PIN, or banking credentials.",
      ],
    },
    {
      icon: <CookieOutlined fontSize="large" color="secondary" />,
      title: "Cookies",
      points: [
        "Keep users logged in",
        "Improve website performance",
        "Analyse website traffic",
        "Personalize user experience",
        "Users can disable cookies through browser settings.",
      ],
    },
    {
      icon: <CloudOutlined fontSize="large" color="info" />,
      title: "Third-Party Services",
      points: [
        "Razorpay (Payments)",
        "Google Analytics",
        "AWS Cloud Services",
        "Email & SMS Providers",
      ],
    },
    {
      icon: <SecurityOutlined fontSize="large" color="success" />,
      title: "Data Security",
      points: [
        "Industry-standard security practices are implemented.",
        "Encryption and secure communication protocols protect user information.",
        "Access is restricted to authorized personnel only.",
      ],
    },
    {
      icon: <GavelOutlined fontSize="large" color="error" />,
      title: "Your Rights",
      points: [
        "Request access to your personal data.",
        "Correct inaccurate information.",
        "Delete your account where legally permitted.",
      ],
    },
    {
      icon: <ContactMailOutlined fontSize="large" color="primary" />,
      title: "Contact Us",
      points: [
        "For privacy-related questions or concerns:",
        "privacy@priceworth.com",
      ],
    },
  ];

  return (
    <>
      <div
      style={{
        background: "#f8fafc",
        minHeight: "100vh",
        padding: "50px 0",
      }}
    >
      <Container>

        {/* Hero */}

        <div
          style={{
            background:
              "linear-gradient(135deg,#1e3a8a,#2563eb,#3b82f6)",
            borderRadius: 25,
            padding: "60px 30px",
            color: "#fff",
            textAlign: "center",
            marginBottom: 40,
            boxShadow: "0 20px 45px rgba(37,99,235,.25)",
          }}
        >
          <PrivacyTipOutlined style={{ fontSize: 70 }} />

          <h1
            style={{
              fontWeight: 700,
              marginTop: 20,
            }}
          >
            Privacy Policy
          </h1>

          <p
            style={{
              maxWidth: 800,
              margin: "20px auto",
              lineHeight: 1.8,
              color: "#dbeafe",
            }}
          >
            PriceWorth values your privacy. This Privacy Policy explains
            how we collect, use, protect, and manage your personal
            information when you use our platform.
          </p>

          <div
            style={{
              display: "inline-block",
              background: "rgba(255,255,255,.15)",
              padding: "10px 22px",
              borderRadius: 50,
            }}
          >
            Effective Date: July 2026
          </div>
        </div>

        <Row>
          {sections.map((section, index) => (
            <Col lg="6" className="mb-4" key={index}>
              <Card
                style={{
                  border: "none",
                  borderRadius: 20,
                  boxShadow: "0 10px 30px rgba(0,0,0,.08)",
                  height: "100%",
                }}
              >
                <CardBody style={{ padding: 30 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 20,
                    }}
                  >
                    <div
                      style={{
                        width: 60,
                        height: 60,
                        borderRadius: "50%",
                        background: "#eff6ff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: 18,
                      }}
                    >
                      {section.icon}
                    </div>

                    <h4
                      style={{
                        margin: 0,
                        fontWeight: 700,
                        color: "#1e293b",
                      }}
                    >
                      {section.title}
                    </h4>
                  </div>

                  <ul
                    style={{
                      paddingLeft: 20,
                      lineHeight: 2,
                      color: "#475569",
                    }}
                  >
                    {section.points.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
    <Footer/>
    </>
  
  );
}

export default PrivacyPolicy;